var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoadShow)?_c('div',{staticClass:"col-md-12",staticStyle:{"height":"100vh","display":"flex","justify-content":"center","align-items":"center"}},[_c('b-spinner',{staticStyle:{"width":"10em","height":"10rem"},attrs:{"label":"Large Spinner","type":"grow"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }